import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import { EditableProps } from "@builder/components/editable/editableProps";
import { getStyle, getStylePath } from "@builder/components/editable/helpers";
import NumericInput from "@builder/components/general/NumericInput";
import SliderInput from "@builder/components/general/SliderInput";
import { getValueUnit } from "@builder/components/general/editUtils";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { SmartGridNode } from "@common/build/types";

const StyleSmartGrid = ({ parent, title, stateMode }: EditableProps) => {
    const dispatch = useAppDispatch();
    const smartGridNode = useAppSelector(getSelectedNode) as SmartGridNode;
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);
    const cvModeIndex = cvMode?.id === smartGridNode?.id ? cvMode.index : null;

    const smartGridStyle = getStyle(smartGridNode, ["smartGrid"], stateMode, cvModeIndex);
    const smartGridStylePath = getStylePath(["smartGrid"], stateMode, cvModeIndex);
    const smartGridAttrStyle = getStyle(smartGridNode, ["smartGrid", "style"], stateMode, cvModeIndex);
    const smartGridAttrStylePath = getStylePath(["smartGrid", "style"], stateMode, cvModeIndex);

    const numColumns = smartGridStyle?.default?.columns;
    const numColumnsCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...smartGridStylePath, "columns"], value }));
    };

    const columnGapString = smartGridAttrStyle?.default?.columnGap as string;
    const colGap = getValueUnit(columnGapString);
    const colGapCallback = (value: string, unit: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...smartGridAttrStylePath, "columnGap"], value: value + unit }));
    };

    const numRows = smartGridStyle?.default?.rows;
    const numRowsCallback = (value: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...smartGridStylePath, "rows"], value }));
    };

    const rowGapString = smartGridAttrStyle?.default?.rowGap as string;
    const rowGap = getValueUnit(rowGapString);
    const rowGapCallback = (value: string, unit: string) => {
        dispatch(updateNodeProperty({ propertyPath: [...smartGridAttrStylePath, "rowGap"], value: value + unit }));
    };

    return (
        <SidebarCollapse title={title || "Grid"} parent={parent}>
            {/* <Size noWrapper stateMode={stateMode} parent={parent} excluded={["width", "height", NodeSizes.FIT]} /> */}
            <NumericInput title="Number of columns" value={numColumns || 4} callback={numColumnsCallback} min={1} max={9} />
            <SliderInput title="Space between columns" value={colGap.value} callback={colGapCallback} min={0} max={100} unit={colGap.unit} />
            <NumericInput title="Number of rows" value={numRows || 4} callback={numRowsCallback} min={1} max={9} />
            <SliderInput title="Space between rows" value={rowGap.value} callback={rowGapCallback} min={0} max={100} unit={rowGap.unit} />
        </SidebarCollapse>
    );
};

export default StyleSmartGrid;
